import React from "react";
import { STAGES, paymentStatus } from "@/lib/api";
import { useI18n } from "@/contexts/I18nContext";
import { CheckCircle2, Circle, Loader2 } from "lucide-react";

const STAGE_COLOR = {
  order_confirmed: "#A1A1AA",
  kitchen_preparing: "#F59E0B",
  driver_assigned: "#3B82F6",
  on_the_way: "#3B82F6",
  setup_in_progress: "#D4AF37",
  event_ready: "#10B981",
  completed: "#10B981",
};

export function StatusBadge({ status, withDot = true }) {
  const { t } = useI18n();
  const color = STAGE_COLOR[status] || "#A1A1AA";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className="stage-chip"
      style={{ color, borderColor: `${color}55`, background: `${color}10` }}
    >
      {withDot && <span className="pulse-dot inline-block w-1.5 h-1.5 rounded-full" style={{ background: color }} />}
      {t(`stage.${status}`, status)}
    </span>
  );
}

export function PaymentBadge({ order }) {
  const ps = paymentStatus(order);
  return (
    <span
      data-testid={`payment-badge-${ps.key}`}
      className="stage-chip"
      style={{ color: ps.color, borderColor: `${ps.color}55`, background: `${ps.color}10` }}
    >
      {ps.label}
    </span>
  );
}

export function ProgressTracker({ status, history = [] }) {
  const { t } = useI18n();
  const currentIdx = STAGES.indexOf(status);
  return (
    <div className="space-y-1" data-testid="progress-tracker">
      {STAGES.map((s, i) => {
        const done = i < currentIdx || (i === currentIdx && status === "completed");
        const active = i === currentIdx && status !== "completed";
        const upcoming = i > currentIdx;
        const hist = history.find((h) => h.status === s);
        return (
          <div key={s} className="flex items-start gap-3 py-2">
            <div className="mt-0.5">
              {done ? (
                <CheckCircle2 className="w-5 h-5 text-emerald-500" />
              ) : active ? (
                <Loader2 className="w-5 h-5 animate-spin" style={{ color: "#D4AF37" }} />
              ) : (
                <Circle className="w-5 h-5 text-zinc-700" />
              )}
            </div>
            <div className="flex-1">
              <div className={`text-sm ${active ? "text-white" : done ? "text-zinc-300" : "text-zinc-500"}`}>
                {t(`stage.${s}`, s)}
              </div>
              {hist?.at && (
                <div className="text-xs text-zinc-500 mt-0.5">{new Date(hist.at).toLocaleString()}</div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
